/**
 * Stage 1B-1 Task 10. Pages that used to open for anyone signed in, now gated on
 * the SAME permission as their menu entry (src/next/shell/nav.ts buildMainNav,
 * src/constants/sideBarRoutes.js), so nobody can open by typing the address a
 * page the menu does not offer him. Each entry is [permission, scopeType?]:
 * with a scope type the guard asks canAccessAny (a `limited` member reaches the
 * page through scoped grants), without one it asks hasPermission.
 *
 * /saved-routes/:id takes the Routes entry's rule (/saved-routes).
 */
export const GUARDED_PATHS = {
  "/households": ["read_households", "households"],
  "/my-team": ["read_my_team"],
  "/duchot": ["read_duchot"],
  "/saved-routes/:id": ["read_routes", "routes"],
} as const;

export type GuardedPath = keyof typeof GUARDED_PATHS;

/** PermissionRoute props for a guarded page. */
export const guardFor = (path: GuardedPath): { permission: string; scopeType?: "routes" | "households" } => {
  const [permission, scopeType] = GUARDED_PATHS[path] as readonly [string, ("routes" | "households")?];
  return { permission, scopeType };
};
